function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, useRef } from "react";
import { Tabs, notification, Skeleton, List, Button, DatePicker, Divider, Spin, Drawer, Space } from "antd";
import { ListUl, Cash, PrinterFill } from "react-bootstrap-icons";
import { Row, Col } from "react-bootstrap";
import SellToCustomer from "../components/forms/SellToCustomer";
import moment from 'moment';
import Common from "../components/includes/Common";
import Moment from 'react-moment';
import dayjs from 'dayjs';
import { LoadingOutlined } from '@ant-design/icons';
import DisplayInvoice from "./DisplayInvoice";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var ProvisionHistory = function ProvisionHistory() {
  var ref = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    refresh = _useState2[0],
    setRefresh = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    sales = _useState4[0],
    setSales = _useState4[1];
  var _useState5 = useState(moment().startOf('week').format()),
    _useState6 = _slicedToArray(_useState5, 2),
    From = _useState6[0],
    setFrom = _useState6[1];
  var _useState7 = useState(moment().endOf('week').format()),
    _useState8 = _slicedToArray(_useState7, 2),
    to = _useState8[0],
    setTo = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    salesDataChanged = _useState0[0],
    setSalesDataChanged = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    payoutsDataChanged = _useState10[0],
    setPayoutsDataChanged = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    salesDataError = _useState12[0],
    setSalesDataError = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isSalesLoading = _useState14[0],
    setIsSalesLoading = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showSettle = _useState16[0],
    setShowSettle = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    selectedBill = _useState18[0],
    setSelectedBill = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    userBalance = _useState20[0],
    setUserBalance = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isBalanceLoading = _useState22[0],
    setIsBalanceLoading = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    showInvoice = _useState24[0],
    setShowInvoice = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showSettlementHistory = _useState26[0],
    setShowSettlementHistory = _useState26[1];
  var rangePresets = [{
    label: "Ajourdh'ui",
    value: [dayjs().startOf('day'), dayjs()]
  }, {
    label: "Cette semaine",
    value: [dayjs().startOf('week'), dayjs().endOf('week')]
  }, {
    label: 'Ce mois',
    value: [dayjs().startOf('month'), dayjs().endOf('month')]
  }];
  useEffect(function () {
    setRefresh(false);
    setPayoutsDataChanged(false);
    setIsSalesLoading(true);
    axios.all([axios.get("".concat(Common.baseApiUrl, "getperiodicuserbills/").concat(From, "/").concat(to))]).then(function (response) {
      if (response[0].data.status == 200) {
        setSales(response[0].data.invoices);
      } else {
        setSalesDataError(response[0].data.message);
      }
    })["finally"](function () {
      setIsSalesLoading(false);
    });
  }, [refresh, salesDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        children: [/*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            lg: 8,
            md: 7,
            children: /*#__PURE__*/_jsx(RangePicker, {
              size: "large",
              onChange: function onChange(dates, ds) {
                if (dates) {
                  setFrom(dates[0].format());
                  setTo(dates[1].format());
                }
              },
              format: "DD/MM/YYYY",
              allowClear: true,
              needConfirm: false,
              presets: rangePresets
            })
          })
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsxs("b", {
              children: ["P\xE9riode du ", /*#__PURE__*/_jsx(Moment, {
                date: From,
                format: "DD/MM/YYYY"
              }), " au ", /*#__PURE__*/_jsx(Moment, {
                date: to,
                format: "DD/MM/YYYY"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(List, {
          loading: isSalesLoading,
          itemLayout: "horizontal",
          dataSource: sales,
          renderItem: function renderItem(item) {
            return /*#__PURE__*/_jsx(List.Item, {
              actions: [/*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: function onClick() {
                  setShowSettlementHistory(true);
                  setSelectedBill(item);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(ListUl, {
                    size: 18
                  })
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "default",
                disabled: item.total_amount == item.paid_amount,
                onClick: function onClick() {
                  setSelectedBill(item);
                  setShowSettle(true);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Cash, {
                    size: 18
                  })
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: function onClick() {
                  setSelectedBill(item);
                  setShowInvoice(true);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(PrinterFill, {
                    size: 18
                  })
                })
              })],
              children: /*#__PURE__*/_jsx(Skeleton, {
                avatar: true,
                title: false,
                loading: isSalesLoading,
                active: true,
                children: /*#__PURE__*/_jsx(List.Item.Meta, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(Moment, {
                      date: item.created_at,
                      format: "DD/MM/YYYY HH:mm"
                    })
                  }),
                  description: "Montant : " + item.total_amount.toLocaleString("Fr") + "GNF , Payé: " + item.paid_amount.toLocaleString("Fr") + "GNF, Client: " + item.lead.name
                })
              })
            });
          }
        })]
      })
    }), selectedBill && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS DEVIS"
        }),
        width: "80%",
        open: showInvoice,
        onClose: function onClose() {
          setShowInvoice(false);
        },
        destroyOnClose: true,
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref) {
                var handlePrint = _ref.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  onClick: handlePrint,
                  type: "ghost",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "IMPRIMER"
                  })
                });
              }
            })
          })
        }),
        children: /*#__PURE__*/_jsx(DisplayInvoice, {
          ref: ref,
          invoice: selectedBill
        })
      })
    })]
  });
};
export default ProvisionHistory;